<template>
	<div class="ReStaffNotifyConf mt-3">
		
		<h4  v-if="showTitle" class="mb-0 text-primary">Настройка уведомлений</h4> 
		<div class="ReStaffNotifyConf-wrapper">
			<h4 class="mb-0">{{placeholder}}*</h4> 
			<a v-if="typeof value.activate_link !='undefined' && value.activate_link!=''" class="btn btn-simple btn-success" :href="value.activate_link" target="_blank">Подключить</a>
			<base-checkbox v-model="value.is_send">Отправлять уведомления</base-checkbox>
			<label calss="col-form-label">*Нажмите кнопку для подключения. Подключение к уведомлениям в мессенджере доступно с личных устройств, где установлено приложение. В открывшемся приложении нажмите "Запустить" или "Start".</label>
		</div>	
	</div>
</template>

<script>
	import { BaseCheckbox } from 'src/components/index';
	export default {
		name: 'ReStaffNotifyConf',
		components: {
			BaseCheckbox,
		},
		props: {
			value: Object,
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			showTitle:{
				type: Boolean,
				default: true
			},
			placeholder: String,
		},
		data () {
			return {
				ver: 1,
			}
		},
		computed: {

		},
		methods: {

		},
	}
</script>
<style scoped>
	/* .ReStaffNotifyConf{display: flex; flex-wrap: wrap; flex-direction: column;} */
	.ReStaffNotifyConf-wrapper{display: flex; align-items: baseline; flex-wrap: wrap;}
	.ReStaffNotifyConf-wrapper > * {display: inline-block; margin-right: 10px;}
</style>
